import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import { WeekPlanSpecialDayPlan } from "../models/weekplan-special-dayplan.model";

@Injectable({
  providedIn: "root"
})
export class WeekPlansService extends ApiBaseService {
  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", APIKEY: "ams-direct-api-admin-key", SessionId: this.userService.sessionId }) };
    this.baseUrl = `${this.configService.config.adminUrl}/api/weekplan`;
  }

  get(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/get`, this.httpOptions);
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/get?id=${id}`, this.httpOptions);
  }

  getEmployeesByWeekPlan(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/getemployeesbyweekplan?id=${id}`, this.httpOptions);
  }

  getTreeData(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/gettreedata`, this.httpOptions);
  }

  getAddNew(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/getaddnew`, this.httpOptions);
  }

  save(weekplan: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/save`, weekplan, this.httpOptions)
      .pipe(catchError(this.handleError<any>("Save failed", null)));
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/delete?id=${id}`, this.httpOptions)
      .pipe(catchError(this.handleError<boolean>(`Failed to delete weekplan with id ${id}`, false)));
  }

  updateEmployeeWeekplan(employeeId: number, weekplanId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/updateemployeeweekplan?employeeId=${employeeId}&weekplanId=${weekplanId}`, this.httpOptions);
  }

  getWeekPlanSpecialDayPlans(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/getAllWeekPlanSpecialDayPlans`, this.httpOptions);
  }

  addWeekPlanSpecialDayPlan(weekPlanSpecialDayPlan: WeekPlanSpecialDayPlan): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/CreateWeekPlanSpecialDayPlan`, weekPlanSpecialDayPlan, this.httpOptions);
  }

  updateWeekPlanSpecialDayPlan(weekPlanSpecialDayPlan: WeekPlanSpecialDayPlan): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/UpdateWeekPlanSpecialDayPlan`, weekPlanSpecialDayPlan, this.httpOptions);
  }

  deleteWeekPlanSpecialDayPlan(weekPlanSpecialDayPlan: WeekPlanSpecialDayPlan): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/DeleteWeekPlanSpecialDayPlan`, weekPlanSpecialDayPlan, this.httpOptions);
  }

  deleteMultipleWeekPlanSpecialDayPlan(weekPlanSpecialDayPlans: WeekPlanSpecialDayPlan[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/DeleteMultipleWeekPlanSpecialDayPlan`, weekPlanSpecialDayPlans, this.httpOptions);
  }

}
